import React, { useState } from 'react';
import './Auth.css';
import { useNavigate } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEye, faEyeSlash } from '@fortawesome/free-solid-svg-icons';
import { toast, ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import ccjabLogo from '../images/banner.png'; // logo principal

const RegisterPage = () => {
  const [form, setForm] = useState({
    username: '',
    email: '',
    password: '',
    confirmPassword: '',
  });

  const [showPassword, setShowPassword] = useState(false);
  const [showConfirm, setShowConfirm] = useState(false);
  const [avatar, setAvatar] = useState(null);
  const [avatarPreview, setAvatarPreview] = useState(null);
  const navigate = useNavigate();

  const handleChange = (e) => {
    setForm({ ...form, [e.target.name]: e.target.value });
  };

  const handleAvatarChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      setAvatar(file);
      setAvatarPreview(URL.createObjectURL(file));
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (form.password !== form.confirmPassword) {
      toast.error('❌ Les mots de passe ne correspondent pas.');
      return;
    }

    const data = new FormData();
    data.append('username', form.username);
    data.append('email', form.email);
    data.append('password', form.password);
    if (avatar) data.append('avatar', avatar);

    try {
      const response = await fetch('https://ccjab.pro/api/register.php', {
        method: 'POST',
        body: data,
      });

      const text = await response.text();
      let result;
      try {
        result = JSON.parse(text);
      } catch (e) {
        result = { message: 'Erreur inconnue du serveur' };
      }


      if (response.ok) {
        const profilePhoto = result.profile_photo
          ? `https://ccjab.pro/${result.profile_photo}`
          : 'https://cdn-icons-png.flaticon.com/512/5781/5781402.png';

        // Stocker user
        localStorage.setItem(
          'user',
          JSON.stringify({
            username: form.username,
            email: form.email,
            profile_photo: profilePhoto,
            role: 'user',
          })
        );

        toast.success('Inscription réussie ! Redirection...');
        setTimeout(() => navigate('/login'), 2000);
      } else {
        toast.error(result.message || "Erreur d'inscription");
      }
    } catch (err) {
      console.error(err);
      toast.error("Une erreur s'est produite.");
    }
  };

  return (
    <div className="auth-container">
      <div className="auth-card">

        {/* Logo CCJAB */}
        <div className="auth-logo-wrapper">
          <img src={ccjabLogo} alt="Logo CCJAB" className="auth-logo" />
        </div>

        {/* Upload avatar */}
        <div className="avatar-upload">
          <label className="avatar-preview">
            {avatarPreview ? (
              <img src={avatarPreview} alt="Avatar" />
            ) : (
              <span>+</span>
            )}
            <input
              type="file"
              accept="image/*"
              style={{ display: 'none' }}
              onChange={handleAvatarChange}
            />
          </label>
        </div>

        {/* Formulaire */}
        <form onSubmit={handleSubmit}>
          <input
            type="text"
            name="username"
            placeholder="Nom d'utilisateur"
            value={form.username}
            onChange={handleChange}
            required
          />

          <input
            type="email"
            name="email"
            placeholder="Adresse email"
            value={form.email}
            onChange={handleChange}
            required
          />

          <div className="password-wrapper">
            <input
              type={showPassword ? 'text' : 'password'}
              name="password"
              placeholder="Mot de passe"
              value={form.password}
              onChange={handleChange}
              required
            />
            <FontAwesomeIcon
              icon={showPassword ? faEyeSlash : faEye}
              className="eye-icon"
              onClick={() => setShowPassword(!showPassword)}
            />
          </div>

          <div className="password-wrapper">
            <input
              type={showConfirm ? 'text' : 'password'}
              name="confirmPassword"
              placeholder="Confirmer le mot de passe"
              value={form.confirmPassword}
              onChange={handleChange}
              required
            />
            <FontAwesomeIcon
              icon={showConfirm ? faEyeSlash : faEye}
              className="eye-icon"
              onClick={() => setShowConfirm(!showConfirm)}
            />
          </div>

          <button type="submit">S’inscrire</button>
        </form>

        <p>Déjà un compte ? <a href="/login">Se connecter</a></p>
      </div>

      <ToastContainer position="top-center" />
    </div>
  );
};

export default RegisterPage;